import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { StatusApp } from './StatusApp'
import './status.css'

const container = document.getElementById('root')
if (!container) throw new Error('Missing #root element')

createRoot(container).render(
  <StrictMode>
    <StatusApp />
  </StrictMode>,
)
